import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { MembershipCard } from "../../Price/MembershipCard/MembershipCard";
import styles from "./MembershipSlice.module.scss";
import { useState } from 'react';
import { ComparePlans } from "../../Price/ComparePlans/ComparePlans";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var MembershipSlice = function MembershipSlice(_ref) {
  var _memberShipChoice$fir, _memberShipChoice$fir2, _memberShipChoice$sec, _memberShipChoice$sec2, _memberShipChoice$sel;
  var _ref$headerText = _ref.headerText,
    headerText = _ref$headerText === void 0 ? '' : _ref$headerText,
    _ref$subHeaderText = _ref.subHeaderText,
    subHeaderText = _ref$subHeaderText === void 0 ? '' : _ref$subHeaderText,
    _ref$memberShipChoice = _ref.memberShipChoice,
    memberShipChoice = _ref$memberShipChoice === void 0 ? {} : _ref$memberShipChoice,
    _ref$compareData = _ref.compareData,
    compareData = _ref$compareData === void 0 ? {} : _ref$compareData;
  var _useState = useState('first'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPlan = _useState2[0],
    setSelectedPlan = _useState2[1];
  var getButtonStyle = function getButtonStyle(planName) {
    return selectedPlan === planName ? styles.togglePill : styles.togglePillOff;
  };
  var buttonClick = function buttonClick(planName) {
    setSelectedPlan(planName);
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.membershipSlice,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.header,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.mainHeader,
          children: headerText
        }), /*#__PURE__*/_jsx("div", {
          className: styles.subHeader,
          children: subHeaderText
        })]
      }), memberShipChoice && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.toggleButton,
          children: [/*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
            className: getButtonStyle('first')
          }, (_memberShipChoice$fir = memberShipChoice.first) === null || _memberShipChoice$fir === void 0 ? void 0 : _memberShipChoice$fir.buttonAttributes), {}, {
            onClick: function onClick() {
              return buttonClick('first');
            },
            children: (_memberShipChoice$fir2 = memberShipChoice.first) === null || _memberShipChoice$fir2 === void 0 ? void 0 : _memberShipChoice$fir2.buttonText
          })), /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
            className: getButtonStyle('second')
          }, (_memberShipChoice$sec = memberShipChoice.second) === null || _memberShipChoice$sec === void 0 ? void 0 : _memberShipChoice$sec.buttonAttributes), {}, {
            onClick: function onClick() {
              return buttonClick('second');
            },
            children: (_memberShipChoice$sec2 = memberShipChoice.second) === null || _memberShipChoice$sec2 === void 0 ? void 0 : _memberShipChoice$sec2.buttonText
          }))]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.cardWrapper,
          children: /*#__PURE__*/_createElement(MembershipCard, _objectSpread(_objectSpread({}, (_memberShipChoice$sel = memberShipChoice[selectedPlan]) === null || _memberShipChoice$sel === void 0 ? void 0 : _memberShipChoice$sel.card), {}, {
            key: "cardPlan_".concat(selectedPlan)
          }))
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.compareWrapper,
        children: /*#__PURE__*/_jsx(ComparePlans, _objectSpread({}, compareData))
      })]
    })
  });
};